import { IPractitioner, labs, patients } from "lobbie";
import { TQueryRequest } from "src/hooks/useAxios";
import { LabVendor } from "src/schemas/settings/labs/LabVendor";

export const formatPhone = (input: string) => {
    if (!input) {
        return "";
    }
    const phoneNumber = input.trim();

    if (phoneNumber.length !== 10) {
        return phoneNumber;
    }

    const areaCode = phoneNumber.substring(0, 3);
    const middle = phoneNumber.substring(3, 6);
    const last = phoneNumber.substring(6, 10);

    return `+1 ${areaCode}-${middle}-${last}`;
};

export const fetchLabVendors = async (secureGet: TQueryRequest) => {
    return await secureGet(`/staff/labs/vendors`).then(
        (res) => (res && (res.data as LabVendor[])) ?? null,
    );
};

export const fetchLabPrintData = async (secureGet: TQueryRequest, lab: labs.ILab) => {
    return await Promise.all([
        secureGet(`/staff/patients/${lab.accountPatientId}`).then(
            (res) => (res && (res.data as patients.IAccountPatient)) ?? null,
        ),
        fetchLabVendors(secureGet),
        lab.appointmentId
            ? secureGet(`/staff/appointments/${lab.appointmentId}/practitioner`).then(
                  (res) => (res && (res.data as IPractitioner)) ?? null,
              )
            : null,
    ]);
};
